import React, { useEffect, useState } from "react";
import cisl from "../../src/assets/logo.png";
import "./Navbar.css";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [active, setActive] = useState("home");

  // const handleClick = (val) => {
  //   if (val === "logo") setActive("home");
  //   else setActive(val);
  // };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const location = useLocation();

  function makeCall() {
    window.location.href = "tel:+919821294451";
  }

  useEffect(() => {
    // set active based on current pathname so highlight is immediate
    const p = location.pathname || "/";
    if (p === "/" || p === "") setActive("home");
    else if (p.startsWith("/about")) setActive("about");
    else if (p.startsWith("/services")) setActive("services");
    else setActive(""); // fallback
  }, [location]);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        {/* <Link to="/"> */}
        <Link to="/">
          <img src={cisl} alt="Logo" />
        </Link>
        {/* </Link> */}
      </div>

      <div className={`navbar-menu ${isMenuOpen ? "active" : ""}`}>
        <ul>
          {/* <Link to="/"> */}
          <li>
            <Link
              to="/"
              // onClick={() => handleClick("home")}
              style={{ color: active === "home" ? "#60A1D3" : "" }}
            >
              Home
            </Link>
          </li>
          {/* </Link> */}
          {/* <Link to="/"> */}
          <li>
            <Link
              to="/aboutus"
              // onClick={() => handleClick("about")}
              style={{ color: active === "about" ? "#60A1D3" : "" }}
            >
              About Us
            </Link>
          </li>
          {/* </Link> */}
          {/* <Link to="/"> */}
          <li>
            <Link
              to="/servicesandproducts"
              // onClick={() => handleClick("services")}
              style={{ color: active === "services" ? "#60A1D3" : "" }}
            >
              Services
            </Link>
          </li>
          {/* </Link> */}
          <div className={`contact-us-mobile ${isMenuOpen ? "active" : ""}`}>
            <button>Contact Us</button>
          </div>
        </ul>
      </div>
      <div className="contact-us">
        <button onClick={makeCall}>Contact Us</button>
      </div>
      <div className="navbar-toggle" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </nav>
  );
}
